// Wishlist management using localStorage

export const addToWishlist = (routeId) => {
  const wishlist = getWishlist();
  if (!wishlist.includes(routeId)) {
    wishlist.push(routeId);
    localStorage.setItem('routevote_wishlist', JSON.stringify(wishlist));
  }
  return wishlist;
};

export const removeFromWishlist = (routeId) => {
  const wishlist = getWishlist();
  const filtered = wishlist.filter(id => id !== routeId);
  localStorage.setItem('routevote_wishlist', JSON.stringify(filtered));
  return filtered;
};

export const getWishlist = () => {
  const stored = localStorage.getItem('routevote_wishlist');
  return stored ? JSON.parse(stored) : [];
};

export const isInWishlist = (routeId) => {
  return getWishlist().includes(routeId);
};

export const toggleWishlist = (routeId) => {
  if (isInWishlist(routeId)) {
    return removeFromWishlist(routeId);
  } else {
    return addToWishlist(routeId);
  }
};
